import { compact, some, chain, isEmpty, includes, isArray } from "lodash";

class CompactInfoManager {
    filterCompactInfoAnnotations(convention) {
        if (!convention.annotationsByKey) return [];
        const annotationTitleConfigByKey = this.buildAnnotationTitlesConfigByKey(
            convention.sections,
            Object.keys(convention.annotationsByKey)
        );
        return (this.compactInfoAnnotations = this.compactInfoAnnotations =
            chain(convention.annotationsByKey)
                .mapValues(annotations => {
                    return compact(
                        annotations.map(annotation => {
                            return some(annotation.tags, tag => tag === "compact-info")
                                ? annotation
                                : null;
                        })
                    );
                })
                .omitBy(isEmpty)
                .mapKeys((value, key) => annotationTitleConfigByKey[key])
                .value());
    }

    buildAnnotationTitlesConfigByKey(
        sections,
        annotationsTitleKeys,
        titlesConfigByKey = {},
        subSectionTitleKeys = []
    ) {
        if (isArray(sections) && sections.length > 0) {
            sections.forEach(section => {
                if (includes(annotationsTitleKeys, section.key))
                    titlesConfigByKey[section.key] =
                        subSectionTitleKeys.length > 0
                            ? `${subSectionTitleKeys.join("/")}/${section.key}`
                            : section.key;

                if (section.children && !isEmpty(section.children)) {
                    this.buildAnnotationTitlesConfigByKey(
                        section.children,
                        annotationsTitleKeys,
                        titlesConfigByKey,
                        [...subSectionTitleKeys, `${section.key}`]
                    );
                }
            });
        }
        return titlesConfigByKey;
    }

    buildDisplayedAnnotations(
        sections,
        annotationsByTitlePath,
        annotationsTitlePathKeys,
        titlePath = ""
    ) {
        return sections
            .map(section => {
                const shouldKeepTitle = some(annotationsTitlePathKeys, key =>
                    includes(key.split("/"), section.key)
                );
                const annotationPath =
                    titlePath === "" ? section.key : `${titlePath}/${section.key}`;
                return shouldKeepTitle
                    ? {
                          title: section.title,
                          type: section.type,
                          key: annotationPath,
                          annotations: annotationsByTitlePath[annotationPath],
                          children: this.buildDisplayedAnnotations(
                              section.children || [],
                              annotationsByTitlePath,
                              annotationsTitlePathKeys,
                              annotationPath
                          ),
                      }
                    : null;
            })
            .filter(i => i !== null);
    }
}

const compactInfoManager = new CompactInfoManager();
export default compactInfoManager;
